import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
@NgModule({
  declarations: [ModalComponent],
  imports: [CommonModule, ButtonModule, IconModule],
  exports: [ModalComponent],
})
export class ModalModule {}
